//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"FeatureBaseName",1,0],[0,"InferMultiGeomFeature",1,0],[0,"InspectGeometryMask",1,0],[0,"PathType",1,0],[0,"QuickTolerance",1,0],[1,"SelectInspectGeometry",0,"SelectNXObjectList",0],[1,"SelectPMI",0,"SelectNXObjectList",0],[0,"SelectionMethod",1,0]],[[[],"ShowInspectGeometry",{},0,0],[[],"AddTolerance",{R_:{operation:"CAM.Operation"}},0,0],[["selectedObject"],"DeleteTolerance",{},1,0],[["selectedObject"],"DeleteFeature",{},1,0],[[],"EditDisplay",{},0,0],[[],"UpdateSensors",{},0,0],[[],"ProcessSelectedGeometry",{},0,0],[[],"ProcessSelectedPMI",{},0,0],[["add","objects"],"ProcessGeometryGroup",{},2,0],[[],"ChangeGeometryGroup",{R_:{isNew:''}},0,0],[[],"ChangeMethod",{},0,0],[[],"EditEntryExitPoints",{},0,0],[[],"EditStartEndPoints",{},0,0],[[],"InspectFeatures",{},0,0]],[]];
SPLM.CAM.InspectionOperationBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionOperationBuilder.SelectionMethodType = Object.freeze({
    "Faces" : "Faces", "Edges" : "Edges", "Points" : "Points", "Pmi" : "Pmi", "Feature" : "Feature"});

SPLM.CAM.InspectionOperationBuilder.InspectionPathType = Object.freeze({
    "TouchPoint" : "TouchPoint", "Scan3Axis" : "Scan3Axis", "Scan5Axis" : "Scan5Axis", "FromMethod" : "FromMethod"});

export default SPLM;